
import { Vue, Component, Watch } from 'vue-property-decorator'

import { ServerState, ErgState, Erg } from 'shared/state'
import ViewportSize from 'display/ViewportSize'
import { config, GlobalConfig, GlobalTheme, RaceConfig } from 'display/config'
import { displayType } from 'shared/util'
import { version } from 'package.json'
import globalCssVars from '_display/cssVars'

import { install } from 'resize-observer'
import { PreRaceState } from 'shared/state'
import type { Machine, PreRaceT } from 'shared/types/erg'
import { Racer } from '_display/_race/types'
import { bus } from 'shared/state/Bus'

@Component({ components: { } })
export default class DevPanel extends Vue {

	config = config.vals
	viewport = ViewportSize
	version = version


	@ServerState('state') serverState
	@ErgState() definition
	@ErgState() status
	@GlobalConfig() devMode
	@GlobalConfig() route
	@GlobalConfig() disablePreraceMessages!: boolean
	@PreRaceState() pre_race!: PreRaceT
	@ErgState() current_elimination_round: number
	@RaceConfig() autoScale!: boolean
	@RaceConfig() autoScaleDelay!: number
	@RaceConfig() autoScalePct!: number


	eliminated = []
	atRisk = []
	focusedRacers = []
	eliminations_this_round = 0
	extent = {}
	zoomIn: string | number = ''
	zoomOut: string | number = ''
	canZoomIn: string | number = ''
	canZoomOut: string | number = ''
	racersDelta: string | number = ''
	zoomOutDelta: string | number = ''
	autoScaleThreshold: string | number = ''
	t = '-'

	get cssVars() {
		return globalCssVars()
	}
	toggle() {
		this.t = this.t === '-' ? '+' : '-'
	}
	get mainBoxStyle() {
		if(this.t === '-') { return }
		return {
			'max-height': '30px',
			overflow: 'hidden'
		}
	}

	racerEssentials(m: Machine, index: number) {
		return {lane: m.lane, name: m.name, position: m.position, index}
	}

	raceDefinitionReceived() {
		this.atRisk = []
		this.eliminated = []
		this.focusedRacers = []
		this.extent = {}
		this.zoomIn =
		this.zoomOut =
		this.canZoomIn =
		this.canZoomOut =
		this.racersDelta =
		this.zoomOutDelta =
		this.autoScaleThreshold = ''
	}

	raceDataReceived(machines: Machine[]) {
		this.atRisk = machines.filter(m => m.is_at_risk && !m.is_eliminated).map(this.racerEssentials)
		this.eliminated = machines.filter(m => m.is_eliminated).map(this.racerEssentials)
		this.eliminations_this_round = Erg.eliminations_this_round
	}
	updatefocusedRacers(rc: Racer[], extent?) {
		if(!['race running', 'race running - sound horn'].includes(Erg.status)) { return }
		this.focusedRacers = rc.map(r => r.lane)
		extent.lead = Math.round(extent.lead)
		extent.tail = Math.round(extent.tail)
		extent.zoomOutTail = Math.round(extent.zoomOutTail)
		this.extent = extent
	}
	closeStyle(a, b, compare) {
		if (Math.abs(a - b) < 11 && compare) {
			return {color: 'red'}
		}
		return {color: 'white'}
	}
	zoomInfo(zoomIn, zoomOut, canZoomIn, canZoomOut, racersDelta, zoomOutDelta, autoScaleThreshold: number) {
		this.zoomIn = Math.round(zoomIn)
		this.zoomOut = Math.round(zoomOut)
		this.canZoomIn = canZoomIn
		this.canZoomOut = canZoomOut
		this.racersDelta = Math.round(racersDelta)
		this.zoomOutDelta = Math.round(zoomOutDelta)
		this.autoScaleThreshold = autoScaleThreshold
	}
	created() {
	Erg.$on('race_definition', this.raceDefinitionReceived)
	Erg.$on('race_data', this.raceDataReceived)
	bus.$on('focused_racers', this.updatefocusedRacers)
	bus.$on('zoom', this.zoomInfo)
	}
beforeDestroy() {
		Erg.$off('race_data', this.raceDataReceived)
		Erg.$off('race_definition', this.raceDefinitionReceived)
		bus.$off('focused_racers', this.updatefocusedRacers)
		bus.$off('zoom', this.zoomInfo)
	}
@Watch('pre_race', {immediate: true, deep: true})
	private preraceChanged(newVal) {
	 if(!newVal) { return }
	 if(newVal.id !== null && this.status === 'inactive') {
		Erg.clearDefinition()
	}
	}

}
